import type { ImageVariant as GQLImageVariant } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export type CheckoutImageVariant = {
  variant: string;
  src: string;
};

export const fromGql = (gqlImageVariant: GQLImageVariant): CheckoutImageVariant =>
  take<CheckoutImageVariant>(gqlImageVariant, 'variant', 'src');
